import axios from 'axios'
import type { Answers, JudgeResult } from './types'

export interface LeadInfo {
  companyName: string
  name: string
  email: string
  phone: string
  privacyAgreed: boolean
}

function csrfToken(): string {
  return document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ''
}

function requestConfig() {
  return {
    headers: {
      'X-CSRF-Token': csrfToken(),
      'Content-Type': 'application/json',
    },
  }
}

// Q1〜Q14 回答完了時点で呼ぶ。会社名等はまだ無い状態でレコードを作成する。
export async function createDiagnosis(
  result: JudgeResult,
  answers: Answers,
  summary: string,
  bottleneck: string,
  inflowRoute: string
): Promise<{ token: string }> {
  const response = await axios.post<{ token: string }>(
    '/training-program/diagnosis',
    {
      result_type: result.type,
      type_name: result.typeName,
      total_sessions: result.totalSessions,
      duration: result.duration,
      modules: result.modules,
      curriculum: result.curriculum,
      inhouse: result.inhouse,
      answers,
      summary,
      bottleneck,
      inflow_route: inflowRoute,
    },
    requestConfig()
  )
  return response.data
}

// 会社名・お名前・メールアドレス入力完了時点で呼ぶ。createで作成済みのレコードを更新する。
export async function submitLead(token: string, lead: LeadInfo): Promise<{ report_url: string }> {
  const response = await axios.patch<{ report_url: string }>(
    `/training-program/diagnosis/${token}`,
    {
      company_name: lead.companyName,
      name: lead.name,
      email: lead.email,
      phone: lead.phone,
      privacy_agreed: lead.privacyAgreed,
    },
    requestConfig()
  )
  return response.data
}

export function extractErrorMessages(error: unknown): string[] {
  if (axios.isAxiosError(error) && Array.isArray(error.response?.data?.errors)) {
    return error.response.data.errors as string[]
  }
  return ['送信に失敗しました。時間をおいて再度お試しください。']
}
